import React from 'react'
import { DialogPopup } from '../components'
import { translate } from '../i18n'
import { ImageTargetDeletePopupProps } from './ImageTargetDeletePopup.types'

function ImageTargetDeletePopup({
    onDelete,
    onClose,
}: ImageTargetDeletePopupProps) {
    return (
        <DialogPopup
            open
            variant="error"
            title={translate('projects.image_targets.delete.title')}
            closeText={translate('buttons.cancel') as string}
            button={{
                text: translate('buttons.delete'),
                onClick: onDelete,
            }}
            onClose={onClose}
        >
            {translate('projects.image_targets.delete.description')}
        </DialogPopup>
    )
}

export default ImageTargetDeletePopup
